module.exports = __webpack_public_path__ + "static/img/button.051d082.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/button.png
// module id = Q+6P
// module chunks = 1